import React, { useState } from 'react';
import { FiSearch, FiX, FiPlus, FiBook } from 'react-icons/fi';
import AccountingSidebar from '../components/AccountingSidebar';
import GenericAddModal from '../components/GenericAddModal';
import useLocalState from '../hooks/useLocalState';
import { sortData } from '../utils/tableUtils';

const initialData = [];

export default function AccountingJournals() {
  const [data, setData] = useLocalState('journals_data', initialData);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: 'ref', direction: 'asc' });

  const handleAdd = (newData) => { setData([newData, ...data]); };
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') direction = 'desc';
    setSortConfig({ key, direction });
  };
  const sortedData = sortData(data, sortConfig);

  return (
    <div className="flex h-full font-sans overflow-hidden bg-white">
      <AccountingSidebar />
      <div className="flex-1 flex flex-col bg-[#a6e4e7] p-2">
        <div className="flex justify-between items-center mb-3 px-1 text-gray-800">
          <div className="flex items-center space-x-2">
            <FiBook className="text-xl opacity-70 text-teal-800" />
            <span className="font-medium text-[15px] text-teal-700">Accounting Journals ({data.length})</span>
          </div>
          <button onClick={() => setIsModalOpen(true)} className="bg-[#0000a0] text-white p-1.5 rounded shadow-sm hover:bg-blue-900 transition-colors">
            <FiPlus className="text-sm" />
          </button>
        </div>
        <div className="flex-1 overflow-x-auto bg-white border border-black shadow-sm">
          <table className="min-w-full border-collapse text-[12px] text-gray-800">
            <thead>
              <tr className="bg-[#a6e4e7] text-teal-900 select-none">
                <th onClick={() => handleSort('ref')} className="font-normal p-2 border border-black text-left cursor-pointer">Ref.</th>
                <th onClick={() => handleSort('date')} className="font-normal p-2 border border-black text-left cursor-pointer">Date</th>
                <th onClick={() => handleSort('journal')} className="font-normal p-2 border border-black text-left cursor-pointer">Journal</th>
                <th onClick={() => handleSort('desc')} className="font-normal p-2 border border-black text-left cursor-pointer">Description</th>
                <th onClick={() => handleSort('debit')} className="font-normal p-2 border border-black text-right cursor-pointer">Debit</th>
                <th onClick={() => handleSort('credit')} className="font-normal p-2 border border-black text-right cursor-pointer">Credit</th>
              </tr>
            </thead>
            <tbody>
              {sortedData.map((row, idx) => (
                <tr key={idx} className="bg-white hover:bg-blue-50 transition-colors">
                  <td className="p-2 border border-black">{row.ref}</td>
                  <td className="p-2 border border-black">{row.date}</td>
                  <td className="p-2 border border-black">{row.journal}</td>
                  <td className="p-2 border border-black">{row.desc}</td>
                  <td className="p-2 border border-black text-right">{row.debit}</td>
                  <td className="p-2 border border-black text-right">{row.credit}</td>
                </tr>
              ))}
              {sortedData.length === 0 && <tr><td colSpan="6" className="p-4 text-center text-gray-500">No records found</td></tr>}
            </tbody>
          </table>
        </div>
        <GenericAddModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onAdd={handleAdd} title="Add Journal Entry" fields={[
          { name: 'ref', label: 'Reference' }, { name: 'date', label: 'Date' }, { name: 'journal', label: 'Journal' },
          { name: 'desc', label: 'Description' }, { name: 'debit', label: 'Debit' }, { name: 'credit', label: 'Credit' }
        ]} />
      </div>
    </div>
  );
}